<template>
  <div>
    <div class="space-y-5 p-2 sm:p-5 sm:py-0 md:pt-5">
      <!-- Page Header -->
      <div class="flex items-center justify-between gap-x-5">
        <Breadcrumbs
          :items="[
            { title: 'Dashboard', to: ROUTES.ADMIN.DASHBOARD },
            { title: 'AI Chats', to: ROUTES.ADMIN.CHATS.CHAT_LIST }
          ]"
        />
      </div>
      <!-- End Page Header -->

      <!-- AI Chats Table Card -->
      <div class="flex flex-col space-y-4 rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
        <div>
          <!-- Tab Content -->
          <div class="">
            <!-- Table Section -->
            <div
              class="[&amp;::-webkit-scrollbar]:h-2 [&amp;::-webkit-scrollbar-thumb]:rounded-full
                [&amp;::-webkit-scrollbar-track]:bg-gray-100 [&amp;::-webkit-scrollbar-thumb]:bg-gray-300
                &amp;::-webkit-scrollbar-track]:bg-neutral-700 &amp;::-webkit-scrollbar-thumb]:bg-neutral-500
                overflow-x-auto"
            >
              <div class="inline-block min-w-full align-middle">
                <!-- Table -->
                <PaginatedTableView
                  :fetchData="fetchChatSessions"
                  searchableFields="uuid"
                >
                  <template #table-head>
                    <TableCell>UUID</TableCell>
                    <TableCell>Created At</TableCell>
                    <TableCell>Messages</TableCell>
                    <TableCell>System Rating</TableCell>
                    <TableCell>Human Rating</TableCell>
                    <TableCell></TableCell>
                  </template>
                  <template #table-row="{ items: chatSessions }: { items: AIChatSession[] }">
                    <TableRow
                      v-for="chatSession in chatSessions"
                      :key="chatSession.uuid"
                    >
                      <UniqueTableDataCell :truncate="true">
                        <router-link
                          :to="ROUTES.ADMIN.CHATS.CHAT_DETAIL.replace(':uuid', chatSession.uuid)"
                        >
                          {{ chatSession.uuid }}
                        </router-link>
                      </UniqueTableDataCell>
                      <TableCell>
                        {{ new Date(chatSession.created_at).toLocaleString() }}
                      </TableCell>
                      <TableCell>
                        {{ chatSession.messages.length }}
                      </TableCell>
                      <TableCell>
                        {{ chatSession.system_rating ?? 'N/A' }}
                      </TableCell>
                      <TableCell>
                        {{ chatSession.human_rating ?? 'N/A' }}
                      </TableCell>
                      <TableCell>
                        <router-link
                          class="inline-flex items-center gap-x-2 rounded-lg border border-transparent text-sm font-semibold
                            text-blue-600 hover:text-blue-800 disabled:pointer-events-none disabled:opacity-50
                            dark:text-blue-500 dark:hover:text-blue-400"
                          :to="ROUTES.ADMIN.CHATS.CHAT_DETAIL.replace(':uuid', chatSession.uuid)"
                          type="button"
                        >
                          Details
                        </router-link>
                      </TableCell>
                    </TableRow>
                  </template>
                </PaginatedTableView>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { AiChatSessionsService } from '@/types/generated/services.gen'
  import { type AIChatSession } from '@/types/generated'
  import PaginatedTableView, {
    type FetchDataOptions,
    type PaginatedResponse
  } from '@/components/admin/PaginatedTable.vue'
  import { ROUTES } from '@/router/routes'
  import UniqueTableDataCell from '@/components/admin/table/UniqueTableDataCell.vue'
  import Breadcrumbs from '@/components/admin/breadcrumbs/Breadcrumbs.vue'
  import { TableRow, TableCell } from '@/components/ui/table'
  import CustomerTableDataCell from '@/components/admin/table/CustomerTableDataCell.vue'

  const fetchChatSessions = async (
    options?: FetchDataOptions
  ): Promise<PaginatedResponse<AIChatSession>> => {
    return AiChatSessionsService.aiChatSessionsList({
      limit: options?.limit,
      offset: options?.offset
    }) as unknown as PaginatedResponse<unknown>
  }
</script>

<style scoped></style>
